import { falAngleRight } from 'shared/@generated/icons/falAngleRight';
import { Platform, View } from 'react-native';
import { ReactNode } from 'react';
import { H2 } from 'shared/components/title';
import { Button } from 'shared/components/button';

import { BreederToolsFeaturesList } from 'shared/components/breeder-tools-features-list';

type SellerBreederToolsSectionProps = {
  title: string;
  subtitle: string;
  items: Array<{
    title: string;
    text: string;
    image: ReactNode;
  }>;
  ctaText: string;
  ctaHref: string;
};

const SellerBreederToolsSection = ({
  title,
  subtitle,
  items,
  ctaText,
  ctaHref,
}: SellerBreederToolsSectionProps) => {
  return (
    <View className={Platform.OS === 'web' ? 'mt-20 md:mt-28' : 'mt-12'}>
      <View className={'mx-auto max-w-screen-lg'}>
        <H2 title={title} subtitle={subtitle} center={true} marginTop={false} />
      </View>

      <BreederToolsFeaturesList items={items} />

      <View className={'mt-10 flex items-start md:mt-12 md:items-center md:justify-center'}>
        <Button text={ctaText} icon={falAngleRight} color={'brown'} href={ctaHref} />
      </View>
    </View>
  );
};

export { SellerBreederToolsSection };
export type { SellerBreederToolsSectionProps };
